import VideoBox from "../components/VideoBox.tsx";
import {Grid} from "antd";
import {useHomeRaidData} from "../raids/rest/RaidQueries.ts";
import {PageScrollable} from "../layout/PageScrollable.tsx";
import {useEffect, useState} from "react";
import type {Raids} from "@/raids/rest/RaidSchema.ts";
import {RaidRunning} from "@/home/RaidRunning.tsx";
import {RaidTop5} from "@/home/RaidTop5.tsx";

function Home() {
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const {data, isLoading} = useHomeRaidData();
  const [top5raids, setTop5Raids] = useState<Raids>([]);
  const [runningRaids, setRunningRaids] = useState<Raids>([]);

  useEffect(() => {
    if (!isLoading && data) {
      setTop5Raids(data.top5);
      setRunningRaids(data.runningRaids);
    }
  }, [isLoading, data]);

  return (
      <PageScrollable>
        <div className={"flex flex-col gap-4 max-w-7xl w-full"}>
          {screens.lg && (
              <div className={"flex justify-center"}>
                <VideoBox/>
              </div>
          )}
          <div className={"min-h-0 flex gap-4 flex-col"}>
            {(isLoading || runningRaids.length > 0) && (
                <RaidRunning runningRaids={runningRaids} isLoading={isLoading} />
            )}
            <RaidTop5 isLoading={isLoading} top5Raids={top5raids} />
          </div>
        </div>
      </PageScrollable>
  );
}

export {Home};
